export default class ToolProps {
    
    constructor () {
        this.color = 'rgba(255,255,255,1)';
        this.text = '';
        this.token = null;
        this.image = null;
        this.gmMode = false;
    }

    set(props) {
        for (let i in props) {
            if (props.hasOwnProperty(i) && typeof this[i] !== 'undefined') {
                this[i] = props[i];
            }
        }
    }

    export (tool) {
        switch(tool) {
            case 'rectangle': 
            case 'ellipse': 
            case 'polygon': 
                return {
                    color: this.color
                }
            case 'text': 
                return {
                    text: this.text,
                    color: this.color
                }
            case 'token': 
                return {
                    token: this.token
                }
            case 'image': 
                return {
                    image: this.image
                }

            default:
                return {
                    color: this.color,
                    text: this.text,
                    token: this.token,
                    image: this.image
                }
        }
    }
}